import { FC } from 'react'

import BeSureBlock from '@/screens/Guarantee/page/ui/BeSureBlock/BeSureBlock'
import { HeroBanner } from '@/screens/Guarantee/page/ui/HeroBanner/HeroBanner'

import { FaqSection } from '@/shared/ui/FaqSection'
import { HorizontalSection } from '@/shared/ui/HorizontalSection'

import { guaranteeFaq } from './data'

export const Guarantee: FC = () => (
	<>
		<HeroBanner
			title={'Гарантия и сервис —\n' + 'все, как раньше'}
			subtitle={
				<>
					При покупке техники Apple в iPort вы получаете 2 года гарантии.*
					<p>*Гарантия на iPhone Duo и наушники Apple составляет 12 месяцев.</p>{' '}
				</>
			}
			imgSrc={`https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/guarantee/blue-shield-frame.png`}
			minTitle
		/>
		<BeSureBlock />
		<HorizontalSection title="Частые вопросы" borderNone>
			<FaqSection items={guaranteeFaq} />
		</HorizontalSection>
	</>
)
